import { setHTMLContentAndExecute } from "@/utils/dom";
import { zodUnsafeValidate } from "@/utils/zod";
import { Auth } from "./auth-dialog/types";

const config = {
  resizable: "yes",
  scrollbars: "no",
  toolbar: "no",
  menubar: "no",
  location: "no",
  directories: "no",
  status: "yes",
  width: 450,
  height: 380,
};

const state: {
  window?: WindowProxy;
  controller?: AbortController;
} = {};

export const openSocialAuth = (
  href: string,
  onSuccess?: (response: Auth.Response) => void,
) => {
  state.window?.close();
  state.controller?.abort();

  const features = Object.entries({
    ...config,
    top: Math.round((window.screen.height - config.height) / 2),
    left: Math.round((window.screen.width - config.width) / 2),
  })
    .map(([name, value]) => `${name}=${value}`)
    .join(",");

  const authWindow = window.open(href, "yii_auth_choice", features);

  if (authWindow === null) {
    return;
  }

  authWindow.focus();

  const controller = new AbortController();

  state.window = authWindow;
  state.controller = controller;

  const interval = setInterval(() => {
    if (authWindow.closed === true) {
      controller.abort();
    }
  }, 200);

  controller.signal.addEventListener("abort", () => {
    clearInterval(interval);

    if (state.window === authWindow) {
      state.window = undefined;
    }

    if (state.controller === controller) {
      state.controller = undefined;
    }
  });

  window.addEventListener(
    "message",
    (event) => {
      if (event.source !== authWindow) {
        return;
      }

      if (event.origin !== window.location.origin) {
        return;
      }

      try {
        const data: Auth.SocialAuthResponse = zodUnsafeValidate(
          Auth.SocialAuthResponseSchema,
          event.data,
        );

        if (data.type !== "social-auth") {
          return;
        }

        onSuccess?.(data.data);

        controller.abort();

        authWindow.close();
      } catch (error) {
        // Ignore invalid messages
      }
    },
    {
      signal: controller.signal,
    },
  );
};

export const createSocialAuth = (selector: string) => {
  const targets = Array.from(
    document.querySelectorAll<HTMLAnchorElement>(selector),
  );

  for (const target of targets) {
    target.addEventListener("click", (event) => {
      event.preventDefault();

      openSocialAuth(target.href);
    });
  }
};

export const updateHeaderButtons = async (api: string) => {
  const response = await fetch(api);
  const html = await response.text();

  const container = document.querySelector("#menu-buttons-pjax");

  if (container !== null) {
    setHTMLContentAndExecute(container, html);
  }
};
